export default __webpack_public_path__ + "static/media/Polygon1.dcb8c609.svg";